/** Niveles de la calificación del cliente (mismos cortes que el API: src/client-rating/score.ts). */
export type RatingLevel = 'excellent' | 'good' | 'fair' | 'risky' | 'none';

export const levelOf = (score: number | null | undefined): RatingLevel =>
  score === null || score === undefined || Number.isNaN(Number(score))
    ? 'none'
    : score >= 4.5
      ? 'excellent'
      : score >= 3.5
        ? 'good'
        : score >= 2.5
          ? 'fair'
          : 'risky';

/** Color del tema para cada nivel (nunca colores fijos: sirve en modo claro, oscuro y con otras marcas). */
export const LEVEL_COLOR: Record<RatingLevel, 'success' | 'info' | 'warning' | 'error' | 'default'> = {
  excellent: 'success',
  good: 'info',
  fair: 'warning',
  risky: 'error',
  none: 'default',
};

/** 4.25 → «4,3» con el separador del idioma. */
export const formatScore = (score: number | null | undefined, locale?: string) =>
  score === null || score === undefined ? '—' : Number(score).toLocaleString(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
